import { setListenersFromSelector } from './listeners';
import { querySelector } from './querySelectors';

const INIT_CLASS = 'tl-init';

let getLength = function(input) {
  let max = parseInt(input.getAttribute('maxlength'), 10);
  let current = input.value.length;

  return max - current;
};

export default function(input, span) {
  let inputKeyUp = function(event) {
    querySelector(`.${span}`, this.parentNode).textContent = getLength(this);
  };

  setListenersFromSelector(
    `.${input}`,
    INIT_CLASS,
    inputKeyUp,
    true,
    'keyup'
  );
};
